import { useCallback, useState } from "react";
import { useReport } from "contexts/ReportContext";
import { updateReportHandle } from "services/handles/ReportHandles";
import * as S from "./commonStyles";
import { IReport } from "interfaces/Report";
import Input from "../../../Input";

export function PaymentTab() {
  const { report } = useReport();

  const [pr, setPr] = useState("0");
  const [rec, setRec] = useState("0");

  const handlePolicemenPayment = useCallback(async () => {
    let reportInfo: Partial<IReport>;

    if (report) {
      const { attachments, occurrence, policeman, status, ...filteredReport } = report;
      reportInfo = filteredReport;
    }

    const numberPr = Number(pr.replaceAll(",", "."));
    const numberRec = Number(rec.replaceAll(",", "."));

    updateReportHandle({
      pr: numberPr,
      rec: report ? report.pr : numberRec,
      report: reportInfo!
    });
  }, [report, pr, rec]);

  return (
    <S.PaymentModalContainer>
      {!report?.rec ? (
        <Input
          defaultValue={report?.rec}
          id="name"
          name="name"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setRec(event.target.value);
          }}
          label="Valor recebido (REC)"
          required={true}
          type="text"
        />
      ) : (
        <h2>
          {report?.rec?.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }) || ""}
        </h2>
      )}
      <Input
        defaultValue={report?.pr}
        id="name"
        name="name"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setPr(event.target.value);
        }}
        label={`Valor a pagar ao PR ${report?.pr
          ? `- (${report?.pr?.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          })})`
          : ""
          }`}
        required={true}
        type="number"
      />

      <S.PaymentButton onClick={() => handlePolicemenPayment()}>
        Atualizar informações de pagamento
      </S.PaymentButton>
    </S.PaymentModalContainer>
  );
}
